import type { Product } from "./types";

/** Orden estable de chips en catálogo (solo se muestran las que tengan productos). */
export const categoryDisplayOrder: readonly Product["category"][] = [
  "mug",
  "mousepad",
  "coaster",
  "thermos",
  "poster_aluminum",
  "puzzle",
  "keychain",
  "tee",
  "hoodie",
  "mystery_box",
];
